import React from 'react';
import { Card, CardContent, Button } from '@lb-classroom/ui';
import Link from 'next/link';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import StarRating from '@components/UI/molecules/StarRating';
import type { TutorCardProps } from './show-tutors-on-slot-modal.types';

export const TutorCard = ({ tutor, onBook }: TutorCardProps) => {
  const { t } = useTranslation('common');

  const handleBook = (e: React.MouseEvent) => {
    e.preventDefault();
    onBook(tutor);
  };

  const tutorProfile = tutor.tutor_profile;
  const avatar = tutor.profile_avatar_url
    .replace('lingualbox-dev', 'lingualbox')
    .replace('lingualbox-staging-sg', 'lingualbox');
  const idOrPermalink = tutor.permalink_url
    ? tutor.permalink_url
    : tutor.id.toString();
  const rating = Math.round(tutorProfile.average_rating);
  const profileLink = `/tutors/${idOrPermalink}`;

  return (
    <li>
      <Card>
        <CardContent>
          <div className="grid grid-cols-12 gap-4 w-full">
            <div className="col-span-4 sm:mb-8 flex flex-col items-center justify-center">
              <div className="max-w-full">
                <Link legacyBehavior href="/tutors/[slug]" as={profileLink}>
                  <a target="_blank">
                    <Image
                      width={96}
                      height={96}
                      alt="user-avatar"
                      className="rounded-full"
                      src={avatar}
                    />
                  </a>
                </Link>
              </div>
            </div>
            <div className="col-span-8 flex flex-col justify-center sm:mb-8">
              <div className="font-semibold text-lg">{tutor.first_name}</div>
              <div className="mt-2 mb-4">
                <span className="flex items-center">
                  <StarRating rating={rating} />
                  <span className="ml-2 text-secondary">
                    ({tutorProfile.review_count})
                  </span>
                </span>
              </div>
              <div>
                <div className="mb-4">
                  <Button onClick={handleBook} className="w-full">
                    {t('classes.book')}
                  </Button>
                </div>
                <div className="mb-4">
                  <Link legacyBehavior href="/tutors/[slug]" as={profileLink}>
                    <a target="_blank">
                      <Button variant="outline" className="w-full">
                        {t('links.viewProfile')}
                      </Button>
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </li>
  );
};
